/**
 * Logo színvariációk megtekintése – /logo-showcase (fejlesztéshez)
 */
import React from 'react';
import { Logo, LogoWhite, LogoMonoDark, LogoMonoBlue, LogoTeal, LogoWarm } from '../components/Logo';

const LogoShowcase = () => {
  const variants = [
    { name: 'Warm (nyerő) – világos háttér', Component: Logo, bg: '#f5f5f5' },
    { name: 'Warm White – sötét háttérre (Navbar, Hero)', Component: LogoWhite, bg: '#1a1a2e' },
    { name: 'Mono Dark', Component: LogoMonoDark, bg: '#f5f5f5' },
    { name: 'Mono Blue', Component: LogoMonoBlue, bg: '#f5f5f5' },
    { name: 'Teal', Component: LogoTeal, bg: '#f5f5f5' },
    { name: 'Warm (narancs akcentus)', Component: LogoWarm, bg: '#f5f5f5' }
  ];

  return (
    <div style={{ padding: 40, fontFamily: 'system-ui, sans-serif' }}>
      <h1 style={{ marginBottom: 8 }}>OscAir logo – színvariációk</h1>
      <p style={{ color: '#666', marginBottom: 32 }}>cost sharing flights • O + repülőgép koncepció</p>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
        {variants.map(({ name, Component, bg }) => (
          <div
            key={name}
            style={{
              background: bg,
              padding: 24,
              borderRadius: 12,
              minWidth: 220,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }}
          >
            <Component style={{ width: 180 }} />
            <span style={{ marginTop: 12, fontSize: 12, color: bg === '#1a1a2e' ? '#999' : '#666' }}>{name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoShowcase;
